(function autoCloseDetails() {
  const closingOn = () => (window.innerWidth < 750 ? 'mobile' : 'desktop');

  document.addEventListener(
    'click',
    function (event) {
      const openDetails = document.querySelectorAll('details[data-auto-close-details][open]');
      if (!openDetails.length) return;

      const mode = closingOn();
      const target = event.target instanceof Node ? event.target : null;

      for (let i = 0; i < openDetails.length; i++) {
        const element = openDetails[i];
        if (!element) continue;
        console.log(element.getAttribute('data-auto-close-details'));
        console.log(mode);
        if (!element.getAttribute('data-auto-close-details')?.includes(mode)) continue;
        if (target && element.contains(target)) continue;
        element.removeAttribute('open');
      }
    },
    { passive: true }
  );
})();
